import {
  SET_ACTIVE_PROFILE,
  USER_LOGOUT,
  UPDATE_ACTIVE_PROFILE
} from '../actions/types'

const initialState = {
  participations: [],
}

export default function activeProfile(state = initialState, action){
  const { profile } = action

  switch (action.type) {
    case SET_ACTIVE_PROFILE:
      return profile
    case UPDATE_ACTIVE_PROFILE:
      let updatedProfile = {
        ...state,
        ...profile
      }
      return updatedProfile
    case USER_LOGOUT:
      return initialState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/activeProfile.js